import homework from '@/api/eschool/homework'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  date_from: moment()
    .add(-7, 'Day')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  status: 1,
  direction: 'ASC',
  files: []

}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_STATUS_VALUE(state, value) {
    state.status = value
  },
  SET_FILES(state, file) {
    state.files = file
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        status: context.state.status
      },
      attrubutes
    )
    return homework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return homework.store(data)
  },
  update(context, data) {
    return homework.update(data)
  },
  changeStatus(context, { id, data }) {
    homework.changeStatus(id, data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await homework.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getSubject(context, { class_id, teacher_id }) {
    return homework.getSubject(class_id, {
      params: {
        teacher_id: teacher_id
      }
    })
  },

  getClass(context, teacher_id) {
    return homework.getClass({
      params: {
        teacher_id: teacher_id
      }
    })
  },
  getTeacher(context) {
    return homework.getTeacher({
      params: {
        fields: {
          setup_teacher_profiles: 'teacher_id,fname_foreign,lname_foreign'
        },
        filter: {
          under_sub_program: true,
          current_branch: true
        },
        page: -1
      }
    })
  },
  removeFileUploaded(context, attributes) {
    return homework.removeFile({
      params: attributes
    })
  },
  sendNotification(context, homework_id) {
    return homework.sendNotification(homework_id)
  },
  getFile(context, homework_id, attrubutes = {}) {
    let params = Object.assign(
      {
        sort: 'updated_at',
        direction: context.state.direction
      },
      attrubutes
    )
    return homework.getFile(homework_id, { params }).then(response => {
      let files = response.files.data
      context.commit('SET_FILES', files)
    })
  },
  deleteItem(context, homework_att_id) {
    return homework.deleteItem(homework_att_id)
  },
}
